import { render } from "./Collapse.vue?vue&type=template&id=6601c38a&ts=true"
import script from "./Collapse.vue?vue&type=script&lang=ts"
export * from "./Collapse.vue?vue&type=script&lang=ts"

import "./Collapse.vue?vue&type=style&index=0&id=6601c38a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__